// Implementação mínima de publish/subscribe (caso não esteja em theme.js)
const PUB_SUB_EVENTS = { cartUpdate: 'cartUpdate' };
const eventBus = new Map();

function subscribe(eventName, callback) {
  if (!eventBus.has(eventName)) {
    eventBus.set(eventName, []);
  }
  const callbacks = eventBus.get(eventName);
  callbacks.push(callback);
  return () => {
    const index = callbacks.indexOf(callback);
    if (index !== -1) {
      callbacks.splice(index, 1);
    }
  };
}

function publish(eventName, data) {
  if (!eventBus.has(eventName)) return;
  const callbacks = eventBus.get(eventName);
  callbacks.forEach(callback => callback(data));
}

// Dependências fornecidas pelo global.js
const ON_CHANGE_DEBOUNCE_TIMER = 300; // Valor padrão, pode ser ajustado

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else {
        console.error('CartItems ou updateQuantity não encontrado no remove button.');
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    console.log('CartItems inicializado:', this); // Depuração
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    console.log('CartItems conectado:', this); // Depuração
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    console.log('Evento change disparado:', event); // Depuração
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
          console.log('CartItems atualizado com sucesso:', sourceQty.innerHTML); // Depuração
        } else {
          console.error('Nenhum cart-items encontrado na resposta do servidor.');
        }
      })
      .catch(e => {
        console.error('Erro ao recarregar o carrinho:', e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    console.log(`Chamando updateQuantity para linha ${line} com quantidade ${quantity}`); // Depuração

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log('Resposta do servidor (/cart/change_url):', parsedState); // Depuração

        // Log detalhado para verificar os dados do item
        if (parsedState.items && parsedState.items[line - 1]) {
          console.log(`Item na linha ${line}:`, parsedState.items[line - 1]);
          console.log(`price para linha ${line}:`, parsedState.items[line - 1].price);
          console.log(`quantity para linha ${line}:`, parsedState.items[line - 1].quantity);
          console.log(`final_line_price para linha ${line}:`, parsedState.items[line - 1].final_line_price);
        } else {
          console.warn(`Item na linha ${line} não encontrado em parsedState.items`);
        }

        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          console.error('Erro na atualização:', parsedState.errors);
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // Atualizar as seções renderizadas
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (parsedState.sections && parsedState.sections[section.section]) {
            const newContent = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            console.log(`Atualizando seção ${section.id} com conteúdo:`, newContent); // Depuração
            elementToReplace.innerHTML = newContent;
            // Verificar se o .cart-item__total foi atualizado
            if (section.id === 'main-cart-items') {
              const updatedTotal = elementToReplace.querySelector(`#CartItem-${line} .cart-item__total`);
              if (updatedTotal) {
                console.log(`.cart-item__total atualizado para linha ${line}:`, updatedTotal.textContent);
              } else {
                console.warn(`.cart-item__total não encontrado na seção atualizada para linha ${line}`);
              }
            }
          } else {
            console.warn(`Seção ${section.section} não encontrada em parsedState.sections`);
          }
        });

        // Fallback para atualizar o .cart-item__total se a renderização falhar
        if (parsedState.items && parsedState.items[line - 1]) {
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem) {
            const totalElement = lineItem.querySelector('.cart-item__total');
            if (totalElement) {
              const price = parsedState.items[line - 1].price; // Preço unitário
              const qty = parsedState.items[line - 1].quantity; // Quantidade atualizada
              const calculatedTotal = price * qty; // Cálculo local
              let formattedPrice;
              try {
                formattedPrice = Shopify.formatMoney(calculatedTotal, window.money_format || 'R$ {{amount}}');
                console.log(`Preço formatado com Shopify.formatMoney: ${formattedPrice}`);
              } catch (e) {
                console.warn('Erro ao formatar o preço com Shopify.formatMoney:', e);
                formattedPrice = `R$ ${(calculatedTotal / 100).toFixed(2)}`;
                console.log(`Usando formato fixo: ${formattedPrice}`);
              }
              totalElement.textContent = formattedPrice;
              console.log(`Atualizando .cart-item__total para linha ${line} com fallback: ${formattedPrice}`); // Depuração
              // Atualizar o input de quantidade no DOM
              if (quantityElement) {
                quantityElement.value = qty;
                console.log(`Input de quantidade atualizado para linha ${line}: ${qty}`);
              }
            } else {
              console.warn(`Elemento .cart-item__total não encontrado para linha ${line}`);
            }
          } else {
            console.warn(`Elemento #CartItem-${line} não encontrado no DOM`);
          }
        } else {
          console.warn(`Item na linha ${line} não encontrado em parsedState.items`);
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((error) => {
        console.error('Erro ao atualizar o carrinho:', error);
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}

// Implementação de Shopify.formatMoney (simplificada)
if (typeof Shopify === 'undefined') window.Shopify = {};
Shopify.formatMoney = function(cents, format) {
  console.log('Chamando Shopify.formatMoney com cents:', cents, 'e format:', format); // Depuração
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = (cents / 100).toFixed(2); // Formato básico: 1234 -> 12.34
  const formatString = format || window.money_format || 'R$ {{amount}}';

  if (!formatString) {
    console.warn('window.money_format não definido, usando formato padrão');
    return `R$ ${value}`;
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatted = formatString.replace(placeholderRegex, value);
  console.log('Preço formatado:', formatted); // Depuração
  return formatted;
};